import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

// import components
import CTABanner from "components/partials/cta-banner";

const NewsletterCtaBuilder: React.FC<{ newsletterCtaData?: Queries.NewsletterCtaBlockFragment }> = ({ newsletterCtaData }) => {

    if (!newsletterCtaData) return null;

    const { datoCmsWebsiteLayout } = useStaticQuery<Queries.CtaBannerDataQuery>(graphql`
        query CtaBannerData {
          datoCmsWebsiteLayout {
            ... WebsiteLayoutSettings
          }
        }
      `)

    let bannerColorClass = `bg-brand-` + newsletterCtaData.colorOption ?? 'teal';

    let buttonText = "Sign Up";
    let buttonUrl = datoCmsWebsiteLayout?.newsletterUrl || "#";
    let target = '_blank';

    let button = {
        buttonText: buttonText,
        buttonUrl: buttonUrl,
        target: target
    };

    return (
        <CTABanner
            headline={newsletterCtaData.heading ?? ''}
            bannerColorClass={`cta-banner--slim ${bannerColorClass}`}
            bannerLarger={false}
            button={button}
        />
    );

}

export default NewsletterCtaBuilder;